import * as React from "react";

function SvgFreshmarketer(props, ref) {
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="2 8 35 35"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M19.44 8.4h12.79a4.26 4.26 0 014.26 4.26v12.79a17 17 0 01-17 17 17 17 0 01-17-17A17 17 0 0119.44 8.4z"
        fill="#ee5a24"
      />
      <ellipse cx={26.72} cy={24.63} rx={0.95} ry={2.63} fill="#fff" />
      <path
        d="M24 24.63A18.72 18.72 0 0125 18a.24.24 0 00-.33-.32l-6.43 3.12a3 3 0 01-1.06.31l-2 .23a3.28 3.28 0 000 6.52h.1l.65 3.66a1.25 1.25 0 102.47-.44l-.5-2.82a2.71 2.71 0 01.3.13l6.43 3.12a.24.24 0 00.33-.32 18.72 18.72 0 01-.96-6.56z"
        fill="#fff"
      />
    </svg>
  );
}

export default React.forwardRef(SvgFreshmarketer);
